import _spinnerAnimation from "./spinner.json";
export var spinnerAnimation = _spinnerAnimation;
